import { config } from '@/config';
import { getAppContainer } from '@/libs/container';
import { RequestConfig } from '@umijs/max';

const authHeaderInterceptor = (url: string, options: any) => {
  const authHeader: any = {};
  const session = getAppContainer().session.get();

  authHeader.Authorization = `Bearer ${session?.access_token}`;
  return {
    url,
    options: {
      ...options,
      interceptors: true,
      headers: authHeader,
    },
  };
};

export const request: RequestConfig = {
  baseURL: config.host,
  timeout: 60000,
  // Add a pre-request interceptor that automatically adds an AccessToken
  requestInterceptors: [authHeaderInterceptor],
  // add error handle for catch 401 error
  errorConfig: {
    errorHandler: async (error) => {
      if (error && 'response' in error && error.response?.status === 401) {
        // clear session before call sign out
        getAppContainer().session.set(null);
        await getAppContainer().userManager.signoutRedirect();
        throw error;
      }
      throw error;
    },
  },
};
